// Autoresponder feature entry — owned by the autoresponder feature.
// One code-split page (/autoresponder) with Rules / Activity / Conversations / Settings tabs (?tab=).
import { MessageCircleReply } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const autoresponder: FeatureModule = {
  id: "autoresponder",
  nav: [{ to: "/autoresponder", label: "Autoresponder", icon: MessageCircleReply, group: "replies", order: 10 }],
  routes: [
    {
      path: "/autoresponder",
      lazy: async () => {
        const { AutoresponderPage } = await import("./AutoresponderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <AutoresponderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default autoresponder;
